import { render, staticRenderFns } from "./GiphyComponent.vue?vue&type=template&id=779faf54&scoped=true&"
import script from "./GiphyComponent.vue?vue&type=script&lang=js&"
export * from "./GiphyComponent.vue?vue&type=script&lang=js&"
import style0 from "./GiphyComponent.vue?vue&type=style&index=0&id=779faf54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779faf54",
  null
  
)

export default component.exports